export enum TEXTAREA_MAX_LENGTH {
    MAX = 4000,
    MIN = 1,
}

enum Gender {
    Male = 'Male',
    Female = 'Female',
    Unknown = 'Unknown',
}

export const enum PlAN_LEVEL {
    CATASTROPHIC = 'CATASTROPHIC',
}

export enum ApplicationType {
    NonFinancial = 'Non-Financial',
    Financial = 'Financial',
}

enum TxnType {
    Change = 'CHANGE',
    Term = 'TERM',
    Add = 'ADD',
}

enum TxnReason {
    EC = 'EC',
    TwentyNine = '29',
    AI = 'AI',
    FiftyNine = '59',
    Fourteen = '14',
    ZeroThree = '03',
    ZeroSeven = '07',
}

const createOptions = (enumObj: any) => {
    return Object.values(enumObj).map((value: string) => ({
        value,
        text: value.charAt(0).toUpperCase() + value.slice(1).toLowerCase(),
    }));
};

export const GENDER_OPTIONS = createOptions(Gender);

export const APPLICATION_TYPES = createOptions(ApplicationType);

export const TXN_TYPES = TxnType;
export const TXN_REASON = TxnReason;

export const TXN_TYPES_OPTIONS_GENERAL = createOptions({
    Change: TxnType.Change,
    Term: TxnType.Term,
});

export const TXN_TYPES_OPTIONS = createOptions({
    Change: TxnType.Change,
    Term: TxnType.Term,
    Add: TxnType.Add,
});

export const LAST_DAY_OF_YEAR = '12/31';

export const TXN_REASONS_TEXT = {
    MEMBER_BENEFIT_SELECTION: 'Member Benefit Selection',
    BENEFIT_SELECTION: 'Benefit Selection',
    NO_REASON_GIVEN: 'No Reason Given',
    NON_PAYMENT: 'Non Payment',
    VOLUNTARY_WITHDRAWAL: 'Voluntary Withdrawal',
    DEATH: 'Death',
    FRAUD_RESCISSION: 'Fraud Rescission',
};

export const CANCEL_FRD_DESCRIPTION = 'CANCEL-FRD';

export enum EnrollmentErrorCode {
    SUCCESS = 200,
    REQUEST_NULL = 201,
    ACTION_NULL = 202,
    ENROLLMENT_ID_NULL = 203,
    NO_ENROLLMENT_FOUND = 204,
    NO_MEMBER_FOUND = 205,
    CHANGE_OUTSIDE_DATES = 206,
    MEMBER_DATES_OUTSIDE = 207,
    MEMBER_LEVEL_DATES = 208,
    START_DATE_BEFORE_BIRTH = 210,
    END_DATE_BEYOND_DEATH = 211,
    END_DATE_BEFORE_START = 212,
    DATE_FIELD_BLANK = 213,
    ENROLLMENT_CANCELLED = 214,
    DATES_NOT_WITHIN_COVERAGE_YEAR = 215,
    OVERLAPPING_ENROLLMENT = 216,
    MEMBER_BENEFIT_END_BEFORE_START = 217,
    SUBSCRIBER_DATES_MISMATCH = 218,
    TECHNICAL_ERROR = 219,
    COVERAGE_YEAR_MISMATCH = 220,
    CUSTOM_ERROR = 227,
    FAILURE_TO_APPLY_CHANGES = 299,
    ENROLLMENT_START_DATE_MISMATCH = 1000,
    ENROLLMENT_END_DATE_MISMATCH = 1001,
    ENROLLMENT_COVERAGE_DATES_MISMATCH = 1002,
    ENROLLMENT_END_DATE_LESS_THAN_START = 1003,
    ENROLLMENT_CANNOT_BE_REINSTATED = 1004,
}

export const ENROLLMENT_ID = 'enrollmentId';
